import { getData } from '../../../get-table'
import { HttpService } from '../../../http.service'
import { ReportBanamexC } from '../types'

const http = new HttpService()

export async function generateBanamexC(data: ReportBanamexC): Promise<string> {
  const response: any = await http.post('reports/', {
    code: data.code,
    parameters: {
      payrolls: data.parameters.payrolls,
      process: data.parameters.process,
      concepts: data.parameters.concepts,
      startDate: data.parameters.startDate,
      endDate: data.parameters.endDate,
      banks: data.parameters.banks,
      currency: data.parameters.currency,
      paymentBases: data.parameters.paymentBases,
      accountTypes: data.parameters.accountTypes,
      employees: data.parameters.employees,
      paymentDate: data.parameters.paymentDate,
      fileNature: data.parameters.fileNature,
      fileCharacteristics: data.parameters.fileCharacteristics,
      paymentMethod: data.parameters.paymentMethod,
      payingBranch: data.parameters.payingBranch,
      fileDescription: data.parameters.fileDescription,
      instructions: data.parameters.instructions,
      numericReference: data.parameters.numericReference,
      alfaNumericReference: data.parameters.alfaNumericReference,
      sequential: data.parameters.sequential,
      term: data.parameters.term,
      reportType: data.parameters.reportType,
    }
  })

  if (response?.data?.data?.error) {
    return response?.data?.data?.error
  }
  return response?.data
}

export async function getPaymentMethod(
  currencyId: string,
  bankId: string,
  paymentId: string,
  companyId?: string
) {
  const where = [
    `payment_methods.is_deleted = false AND payment_methods.company_id = '${companyId}' AND payment_methods.currency_id = '${currencyId}' AND payment_methods.payment_type_id = '${paymentId}'
    AND banks.id = '${bankId}'`
  ]
  const data = await getData<any>({
    tables: ['pg_payment_methods'],
    fields: [
      'payment_methods.id',
      "concat(banks.name, ' - ', payment_methods.custom_fields->>'custom:bankNumberClient') as name"
    ],
    join: [
      "INNER JOIN banks ON (payment_methods.custom_fields->>'custom:bank')::varchar = banks.id::varchar"
    ],
    where
  })

  return data[0].results
}

export function getNatureFile(country: string) {
  const formatFile = new Map<string, any>([
    [
      'MX',
      [
        { id: '05', name: '05 - Pago de Nómina' },
        { id: '07', name: '07 - Nómina Interbancaria' }
      ]
    ]
  ])

  return formatFile.get(country)
}

//Si la naturaleza es 7, 11 o 12 el campo Plazo debe ser obligatorio
export function getTerms(country: string) {
  const formatFile = new Map<string, any>([
    [
      'MX',
      [
        { id: '00', name: '00 - Mismo Día' },
        { id: '24', name: '24 - 24 Horas' }
      ]
    ]
  ])

  return formatFile.get(country)
}

export function getCharacteristicsFile(country: string) {
  const formatFile = new Map<string, any>([
    [
      'MX',
      [
        { id: '0', name: '0 - Es modificable' },
        { id: '1', name: '1 - Es solo lectura' }
      ]
    ]
  ])

  return formatFile.get(country)
}

export async function getAccountTypesByCountry(countryId?: string) {
  const where = [
    `'${countryId}' IN (SELECT jsonb_array_elements_text(countries))`
  ]
  const data = await getData<any>({
    tables: ['pg_account_types'],
    fields: ['id', 'name', 'code'],
    where
  })

  return data[0].results
}

export function getReportType (country: string) {
  const formatFile = new Map<string, any>([
    [
      'MX',
      [
        { id:  '1', name: 'Pago a Nóminas' },
        { id:  '2', name: 'Pago a Pensión' },
      ]
    ],
  ])

  return formatFile.get(country)
}

export async function getLoans(
  payrollIds: string,
  endDate: string,
  loanTypes: string,
  employees: string,
  startDate?: string,
) {
  const data = await getData<any>(
    {
      tables: ['pg_loans'],
      fields: [
        'loans.id as id',
        'loans.employee_id as employeeId',
        'loans.amount',
        'loans.currency_id as currencyId',
        'loans.concept_id as conceptId',
        'loans.quota_amount as quotaAmount',
        'loans.start_date as startDate',
        'loans.end_date as endDate',
        'loans.is_loan_paid as isLoanPaid',
        'loans.is_inactive as isInactive',
        'loans.loan_type_id as loanTypeId',
        'loans.balance as balance',
        'loan_types.code as codeLoanType'
      ],
      where: [
        `loans.payroll_id IN (${payrollIds})`,
        `loans.employee_id IN (${employees})`,
        `loans.start_date <= '${endDate}'`,
        `loans.is_inactive = false`,
        `employees.leave_date is null`,
        `loans.loan_type_id IN (${loanTypes})`
      ],
      join: [
        'INNER JOIN employees ON employees.id = loans.employee_id',
        'INNER JOIN loan_types ON loan_types.id = loans.loan_type_id'
      ]
    },
  )

  let _employees: any = []
  for (const loans of data[0].results) {
    _employees.push(loans.employeeId)
  }
  return _employees
  // return reduceEmployees(_employees)
}

export async function getLoansTypes(codes: any = '') {
  const where = ['is_deleted = false']
  if (codes !== '') where.push(`code IN (${codes})`)
      const data = await getData<any>({
        tables: ['pg_loan_types'],
        fields: ['id'],
        where,
        modifier: ['order by name asc']
      })
    
      return data[0].results
}

export async function getEmployeesLoans(employeesIds: string) {
  const where = [
    `employees.id IN (${employeesIds})`,
    'employee_accounts.is_active_account=true'
  ]

  const data = await getData<any>({
    tables: ['pg_employee_accounts'],
    fields: [
      'employees.id',
      'employees.name',
      'directions.name as direccion',
      'managements.name as gerencia',
      'departments.name as departamento',
      'sucursals.name as sucursal',
      'positions.name as cargo',
      'turns.name as turno',
      'employees.leave_date as fechaSalida',
      'employees.code as codigo',
      'joining_reasons.name as causaIngreso',
      "CONCAT(employees.code,' - ',employees.name) as codigo_name",
      "STRING_AGG(banks.id::text, ', ') as bankId",
      'false as isChecked'
    ],
    join: [
      'INNER JOIN employees ON employee_accounts.employee_id = employees.id',
      'INNER JOIN banks ON employee_accounts.bank_id = banks.id',
      'LEFT JOIN directions ON employees.direction_id = directions.id',
      'LEFT JOIN managements ON employees.management_id = managements.id',
      'LEFT JOIN departments ON employees.department_id = departments.id',
      'LEFT JOIN sucursals ON employees.sucursal_id = sucursals.id',
      'LEFT JOIN positions ON employees.position_id = positions.id',
      'LEFT JOIN turns ON employees.turn_id = turns.id',
      'LEFT JOIN joining_reasons ON employees.joining_reason_id = joining_reasons.id'
    ],
    where,
    modifier: [
      'group by employees.id,employees.name, employees.leave_date, employees.code,directions.name,managements.name,sucursals.name,departments.name,positions.name,turns.name,joining_reasons.name',
      'order by employees.name asc'
    ]
  })

  return data[0].results
}

export function reduceEmployees(employees: Array<[]>) {
  let uniqueEmployees: any = []
  employees.reduce((res: any, value: any) => {
    if (!res[value]) {
      res[value] = value
      uniqueEmployees.push(value)
    }
    return res
  }, {})

  return uniqueEmployees
}
